import { render, staticRenderFns } from "./FireBeginQuestion.vue?vue&type=template&id=1bf23e5c&scoped=true"
import script from "./FireBeginQuestion.vue?vue&type=script&lang=ts"
export * from "./FireBeginQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf23e5c",
  null
  
)

export default component.exports